import { render, staticRenderFns } from "./VLogo.vue?vue&type=template&id=fd1f0a82&"
import script from "./VLogo.vue?vue&type=script&lang=js&"
export * from "./VLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports